import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { login } from '../../../redux/actions/authActions';
import useInfo from '../../../customhooks/user/useinfo';

export default function LogIn() {

	const initialValues = {
		mobileNumber: '',
		password: '',
	};

	const validationSchema = Yup.object().shape({
		mobileNumber: Yup.number()
			.typeError('Enter valid Mobile Number')
			.required('Required'),
		password: Yup.string().required('Required'),
	});

	const loading = useSelector(state => state.login.loading);
	const result = useSelector(state => state.login.loginResult);

	const [success, setSuccess] = useState(false);
	const [failure, setFailure] = useState(false);
	const [msg, setMsg] = useState('');
	const navigate = useNavigate();
	const isUser = useInfo();

	const handleSubmit = (values) => {
		setSuccess(false);
		setFailure(false);
		login(values);
	};

	useEffect(() => {
		if (isUser) {
			navigate('/');
			return;
		}
		if (result) {
			if (result?.status === 'success') {
				setSuccess(true);
				setFailure(false);
				localStorage.setItem('user-info', JSON.stringify(result.data));
				navigate('/');
			}
			if (result?.status === 'failure') {
				setSuccess(false);
				setFailure(true);
			}
			setMsg(result?.message);
		}
	}, [result, isUser, navigate]);

	return (
		<Container component='main' maxWidth='xs'>
			<CssBaseline />
			<Box
				sx={{
					marginTop: 2,
					marginBottom: 6,
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
				}}
			>
				<Grid container justifyContent='flex-start'>
					<Typography component='h1' variant='h5'>
						Login
					</Typography>
				</Grid>
				<Box sx={{ mt: 3 }}>
					<Formik
						initialValues={initialValues}
						onSubmit={handleSubmit}
						validationSchema={validationSchema}
					>
						{({ isSubmitting }) => (
							<Form>
								<Grid container spacing={2}>
									<Grid item xs={12}>
										<Field
											margin='normal'
											as={TextField}
											id='mobileNumber'
											label='Mobile Number'
											name='mobileNumber'
											fullWidth
											required
											autoFocus
											size='small'
											helperText={<ErrorMessage name='mobileNumber' />}
										/>
									</Grid>
									<Grid item xs={12}>
										<Field
											margin='normal'
											as={TextField}
											name='password'
											label='Password'
											type='password'
											id='password'
											fullWidth
											required
											size='small'
											helperText={<ErrorMessage name='password' />}
										/>
									</Grid>

									<Grid container justifyContent='flex-end'>
										<Grid item>
											<Link href='#' variant='body2'>
												Forgot password?
											</Link>
										</Grid>
									</Grid>
									<Button
										type='submit'
										fullWidth
										variant='contained'
										sx={{ mt: 3, mb: 2, ml: 2 }}
										disabled={loading}
									>
										{loading ? 'Loading' : 'LOGIN'}
									</Button>
									<Grid container justifyContent='center'>
										or
									</Grid>
									<Button
										type='submit'
										fullWidth
										variant='contained'
										sx={{ mt: 3, mb: 2, ml: 2 }}
										disabled={isSubmitting}
									>
										{isSubmitting ? 'Loading' : 'LOGIN WITH OTP'}
									</Button>
									<Grid container justifyContent='center'>
										<Grid item>
											<Link href='/signup' variant='body2'>
												{'Don\'t have an account? SignUp Now'}
											</Link>
										</Grid>
									</Grid>
								</Grid>
							</Form>
						)}
					</Formik>
					{
						success &&
						<Alert severity='success'>{msg}</Alert>
					}
					{
						failure &&
						<Alert severity='error'>{msg}</Alert>
					}
				</Box>
			</Box>
		</Container>
	);
}
